/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeAUpIcon24Solid = forwardRef('ArrowShapeAUpIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M10.144 2.795a2.625 2.625 0 0 1 3.712 0l8.73 8.73c.913.913.266 2.475-1.026 2.475H18v5.75A2.25 2.25 0 0 1 15.75 22h-7.5A2.25 2.25 0 0 1 6 19.75V14H2.44C1.148 14 .5 12.438 1.414 11.524l8.73-8.729Z" })));
});
